<template>
  <aside class="fm-sidebar">
    <div class="fm-sidebar-header">
      <button v-if="currentPath.length > 1" class="fm-sidebar-back" @click="$emit('go-back')">
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd"/>
        </svg>
      </button>
      <span class="fm-sidebar-title">{{ currentFolderName || 'Mi unidad' }}</span>
    </div>

    <div class="fm-sidebar-section">
      <div class="fm-sidebar-tree">
        <FMSidebarNode
          v-for="folder in folders"
          :key="folder.uid"
          :node="folder"
          :current-path="currentPath"
          @navigate="$emit('navigate', $event)"
        />
        <p v-if="folders.length === 0" class="fm-sidebar-empty">Sin subcarpetas</p>
      </div>
    </div>

    <div class="fm-sidebar-section fm-sidebar-storage">
      <span class="fm-sidebar-label">Almacenamiento</span>
      <div class="fm-storage-bar">
        <div class="fm-storage-fill" :style="{ width: (storageUsed / storageTotal * 100) + '%' }"></div>
      </div>
      <p class="fm-storage-text">{{ (storageUsed / 1024 / 1024 / 1024).toFixed(1) }} GB de {{ (storageTotal / 1024 / 1024 / 1024).toFixed(1) }} GB usados</p>
    </div>
  </aside>
</template>

<script>
import FMSidebarNode from './FMSidebarNode.vue'
export default {
  name: 'FMSidebar',
  components: { FMSidebarNode },
  props: {
    folders: Array,
    currentFolderName: String,
    currentPath: Array,
    storageUsed: Number,
    storageTotal: Number
  }
}
</script>

<style scoped>
.fm-sidebar {
  width: var(--fm-sidebar-w);
  background: var(--fm-surface);
  border-right: 1px solid var(--fm-border);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-shrink: 0;
}
.fm-sidebar-header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 12px 8px;
  border-bottom: 1px solid var(--fm-border);
  flex-shrink: 0;
}
.fm-sidebar-back {
  background: none;
  border: none;
  padding: 3px;
  cursor: pointer;
  color: var(--fm-text2);
  display: flex;
  align-items: center;
  border-radius: var(--fm-radius-xs);
  transition: background 0.12s, color 0.12s;
  flex-shrink: 0;
}
.fm-sidebar-back:hover { background: var(--fm-surface3); color: var(--fm-text); }
.fm-sidebar-back svg { width: 16px; height: 16px; }
.fm-sidebar-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--fm-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.fm-sidebar-section { padding: 10px 12px; }
.fm-sidebar-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fm-text2);
  margin-bottom: 8px;
  padding: 0 4px;
}
.fm-sidebar-tree { display: flex; flex-direction: column; gap: 1px; }
.fm-sidebar-empty { font-size: 12px; color: var(--fm-text3); padding: 4px 8px; }
.fm-sidebar-storage { margin-top: auto; border-top: 1px solid var(--fm-border); }
.fm-storage-bar {
  height: 4px;
  background: var(--fm-surface3);
  border-radius: 2px;
  overflow: hidden;
  margin: 8px 4px;
}
.fm-storage-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--fm-accent), var(--fm-primary));
  border-radius: 2px;
  transition: width 0.5s;
}
.fm-storage-text { font-size: 11px; color: var(--fm-text2); padding: 0 4px; }
</style>
